import { Box, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useDropzone } from 'react-dropzone';

interface DocumentUploadDropzoneProps {
  file?: File | null;
  existingFileName?: string;
  onFileChange: (file: File | null) => void;
  disabled?: boolean;
}

const MAX_DOCUMENT_SIZE = 10 * 1024 * 1024;

export function DocumentUploadDropzone({
  file,
  existingFileName,
  onFileChange,
  disabled,
}: DocumentUploadDropzoneProps) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'image/*': ['.png', '.jpg', '.jpeg'],
    },
    disabled,
    maxFiles: 1,
    maxSize: MAX_DOCUMENT_SIZE,
    onDrop: (acceptedFiles) => {
      onFileChange(acceptedFiles[0] ?? null);
    },
  });

  const fileLabel = file
    ? `Archivo: ${file.name}`
    : existingFileName
      ? `Archivo: ${existingFileName}`
      : 'Arrastra un documento o haz clic para seleccionar';

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: '2px dashed',
        borderColor: isDragActive ? 'primary.main' : 'grey.400',
        borderRadius: 1,
        p: 3,
        textAlign: 'center',
        cursor: disabled ? 'default' : 'pointer',
        bgcolor: isDragActive ? 'action.hover' : 'background.paper',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <input {...getInputProps()} />
      <AttachFileIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
      <Typography variant="body2" color="text.secondary">
        {fileLabel}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        PDF o imágenes, máximo 10MB
      </Typography>
    </Box>
  );
}
